'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _Style = require('../core/Style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};

exports.default = _react2.default.createClass({
  displayName: 'UIOverlay',

  propTypes: {
    centerContent: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    contextual: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func,
    onOverlayClick: _react.PropTypes.func,
    style: _react.PropTypes.object,
    tabIndex: _react.PropTypes.number,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    width: _react.PropTypes.number.isRequired
  },

  contextTypes: {
    sandboxed: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      centerContent: true,
      contextual: false,
      use: 'dark'
    };
  },
  isSandboxed: function isSandboxed() {
    return this.props.contextual || this.context.sandboxed;
  },
  containsElt: function containsElt(elt) {
    return this.refs.content && this.refs.content.contains(elt);
  },
  handleClick: function handleClick(evt) {
    var _props = this.props,
        onClick = _props.onClick,
        onOverlayClick = _props.onOverlayClick;

    (0, _Functions.callIfPossible)(onClick);
    if (!this.containsElt(evt.target) || evt.target === this.refs.content) {
      (0, _Functions.callIfPossible)(onOverlayClick);
    }
  },
  getClassNameOverlay: function getClassNameOverlay(_ref) {
    var className = _ref.className,
        use = _ref.use;

    return (0, _reactUtils.classNames)(className, 'private-overlay', 'uiOverlay-backdrop', USE_CLASSES[use], {
      'private-overlay--contextual': this.isSandboxed()
    });
  },
  render: function render() {
    var _props2 = this.props,
        centerContent = _props2.centerContent,
        children = _props2.children,
        className = _props2.className,
        __contextual = _props2.contextual,
        __onClick = _props2.onClick,
        __onOverlayClick = _props2.onOverlayClick,
        style = _props2.style,
        tabIndex = _props2.tabIndex,
        use = _props2.use,
        width = _props2.width,
        rest = _objectWithoutProperties(_props2, ['centerContent', 'children', 'className', 'contextual', 'onClick', 'onOverlayClick', 'style', 'tabIndex', 'use', 'width']);

    var computedStyle = _extends({}, style);
    if (centerContent) {
      computedStyle.maxWidth = (0, _Style.remCalc)(width);
    }

    var computedChildrenWrapperClassName = (0, _reactUtils.classNames)({
      'private-modal__container': centerContent
    });

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        className: this.getClassNameOverlay({ className: className, use: use }),
        onClick: this.handleClick,
        tabIndex: this.isSandboxed() ? null : tabIndex
      }),
      _react2.default.createElement(
        'div',
        {
          className: computedChildrenWrapperClassName,
          ref: 'content',
          style: computedStyle
        },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/overlay/UIOverlay.js
// module id = 324
// module chunks = 0